import { FileText } from 'lucide-react';
import { ARTIFACT_CONFIG } from '../constants';
import { Artifact } from '../../../types/chat';

interface ArtifactCardProps {
  artifact: Artifact;
  onView: () => void;
  className?: string;
}

/**
 * ArtifactCard - Card para exibir artifact inline na mensagem
 *
 * Baseado no mockup:
 * - Ícone de documento com fundo amarelo
 * - Título do artifact
 * - Subtítulo "Documento gerado pela TAIS"
 * - Botão "VER ARTEFATO"
 */
export const ArtifactCard = ({ artifact, onView, className = '' }: ArtifactCardProps) => {
  return (
    <button
      onClick={onView}
      className={`
        w-full flex items-center gap-3
        bg-[#1a1a1a] border border-[#333333] rounded-xl
        p-4 mt-3
        hover:border-[#F4CC04]/50 hover:bg-[#1a1a1a]/80
        transition-all duration-200
        cursor-pointer
        group
        text-left
        ${className}
      `}
      title={`Ver artefato: ${artifact.title}`}
      aria-label={`Ver artefato: ${artifact.title}`}
    >
      {/* Ícone */}
      <div className="w-10 h-10 bg-[#F4CC04] rounded-lg flex items-center justify-center flex-shrink-0">
        <FileText size={20} className="text-black" />
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <div className="text-white font-medium text-sm truncate">
          {artifact.title}
        </div>
        <div className="text-[#888888] text-xs mt-0.5">
          {ARTIFACT_CONFIG.defaultSubtitle}
        </div>
      </div>

      {/* Botão VER ARTEFATO */}
      <div
        className="
          bg-[#F4CC04] text-black
          px-4 py-2 rounded-lg
          font-semibold text-xs
          uppercase tracking-wide
          group-hover:bg-[#d4b104]
          transition-colors duration-200
          flex-shrink-0
        "
      >
        {ARTIFACT_CONFIG.viewButtonText}
      </div>
    </button>
  );
};
